// /src/store/actions/statusActions.js
import { conciergeApi } from "../../utils/api";

/**
 * Fetch the QA / service status for the logged-in client.
 *
 * Concierge scopes the response to whoever the bearer token belongs to and
 * returns banded levels only - no message counts - so nothing here needs to
 * filter or round anything before display.
 */
export const fetchServiceStatus = async () => {
  const response = await conciergeApi.get("/status/client");
  return response.data;
};
